import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {  withStyles, Theme, WithStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import * as ReactMarkdown from 'react-markdown';


interface Props {
    readonly open: boolean,
    readonly title: string,
    readonly text: string,
    readonly onDialogClose: () => void,
}

const styles = (theme: Theme) => ({
    contentRoot: {
        // padding: 2 * theme.spacing.unit,
        // paddingTop: 0,
        '& *': {
            ...theme.typography.subtitle1,
            color: theme.palette.text.secondary
        },
    },
});

type Styles = 'contentRoot';

const GenericDialog = ({open, title, text, classes, onDialogClose}: Props & WithStyles<Styles>) => {

    return (
        <Dialog open={open} onClose={onDialogClose}>
            <DialogTitle>
                <FormattedMessage id={title} />
            </DialogTitle>
            <DialogContent className={classes.contentRoot}>
                <ReactMarkdown source={text} escapeHtml={false}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={onDialogClose} color="primary">
                    <FormattedMessage id="ok"/>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles, {withTheme: true})(GenericDialog);


// WEBPACK FOOTER //
// ./src/components/GenericDialogView.tsx